var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.86954H23.5866C23.2857 7.75326 22.8284 6.70134 22.2387 5.73909H12V8.86954Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53015 21.3913H19.4698C20.565 20.5191 21.5042 19.4596 22.2387 18.2609H1.76129C2.49587 19.4596 3.43506 20.5191 4.53015 21.3913Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1739 2.9034C3.23049 3.71579 2.41492 4.67246 1.76129 5.73915H4.1739V2.9034Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 10.7777 12 9.75474 12 8.86955H7.30434V12H4.17389V8.86955H0.413391C0.144375 9.86771 0 10.9169 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1305H23.5867C23.8556 14.1323 24 13.0831 24 12H12Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C10.3336 0 8.74667 0.339984 7.30432 0.953812V5.73914H12C12 4.64639 12 3.717 12 2.60869H19.4698C17.4199 0.976125 14.8241 0 12 0Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece);
export default __webpack_public_path__ + "static/media/greece.fbdfcf7d7f6f063e51e5b2fbf58269a1.svg";
export { ForwardRef as ReactComponent };